<main id="main-content" class="main-content" *ngIf="user">
    <div style="display: flex;">
        <div class="record_count">
            {{length}} Assessments
        </div>
    </div>
    <div class="search-bar">
        <mat-form-field appearance="outline" style="max-width: 120px;">
            <mat-label>Year</mat-label>
            <mat-select [(value)]="filters.fire_discovery_years">
                <mat-option [value]="null">--</mat-option>
                @for (year of yearsArray; track year) {
                <mat-option [value]="year">{{year}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" style="max-width: 120px;">
            <mat-label>Region</mat-label>
            <mat-select [(value)]="filters.region" (selectionChange)="regionChanged()">
                <mat-option [value]="null">--</mat-option>
                @for (region of regions; track region) {
                <mat-option [value]="region">{{region}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Forest</mat-label>
            <input #forest matInput [formControl]="forest_name" [matAutocomplete]="auto" (input)="filter()"
                (focus)="clearForest()" aria-label="Forest Name">
            <mat-icon matSuffix>arrow_drop_down</mat-icon>
            <mat-autocomplete requireSelection #auto="matAutocomplete" (optionSelected)="forestSelected()">
                @for (name of filtered_forest_names | async; track name) {
                <mat-option [value]="name">{{name | forest_filter}}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Fire/Complex Name</mat-label>
            <input matInput [(ngModel)]="filters.baer_name" aria-label="Fire/Complex Name">
        </mat-form-field>
        <button class="usa-button" (click)="search()">Apply</button>
        <button class="usa-button usa-button--secondary" (click)="clearSearch()" *ngIf="!filters_clean">Clear
            Filters</button>
    </div>
    <h1 id="auth-status-heading">
      BAER Authorization Status
    </h1>
    <table mat-table [dataSource]="assessments" class="center"
           matSort matSortDisableClear multiTemplateDataRows
           aria-labelledby="auth-status-heading auth-status-caption"
        (matSortChange)="sortChange($event)">
        <caption id="auth-status-caption" class="usa-sr-only">
          BAER Authorization Status. Columns: Fire/Complex Name, Region, Forest Name, Total Requested,
          Total Authorized, Actions.
        </caption>
        <ng-container matColumnDef="collapse">
            <td class="empty-header" mat-header-cell *matHeaderCellDef style="width: 48px;"></td>
            <td mat-cell *matCellDef="let assessment">
                <button mat-icon-button aria-label="expand row"
                    (click)="(expandedAssessments = expandedAssessments === assessment ? null : assessment);
                    $event.stopPropagation()">
                    @if (expandedAssessments === assessment) {
                    <mat-icon>keyboard_arrow_up</mat-icon>
                    } @else {
                    <mat-icon>keyboard_arrow_right</mat-icon>
                    }
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="region">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
            <td mat-cell *matCellDef="let assessment" class="prewrap">{{assessment.region | line_break}}</td>
        </ng-container>
        <ng-container matColumnDef="baer_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Fire/Complex Name</th>
            <td mat-cell *matCellDef="let assessment">
                <a [routerLink]="'/fire-overview'" [queryParams]="{assessment_id: assessment.assessment_id}">
                    {{assessment.baer_name || "--"}}
                </a>
            </td>
        </ng-container>
        <ng-container matColumnDef="forest_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Forest Name</th>
            <td mat-cell *matCellDef="let assessment" class="prewrap">{{assessment.forest_name | forest_filter |
                line_break}}</td>
        </ng-container>
        <ng-container matColumnDef="total_req">
            <th mat-header-cell *matHeaderCellDef style="width: 200px;">
                Total Requested
            </th>
            <td mat-cell *matCellDef="let assessment" style="width: 200px;">
                {{'$'+(assessment.total_req ?? 0 | number:'1.2-2') | empty_check}}
            </td>
        </ng-container>
        <ng-container matColumnDef="total_auth">
            <th mat-header-cell *matHeaderCellDef style="width: 200px;">
                Total Authorized
            </th>
            <td mat-cell *matCellDef="let assessment" style="width: 200px;">
                {{'$'+(assessment.total_auth ?? 0 | number:'1.2-2') | empty_check}}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef style="width: 170px;">Actions</th>
            <td mat-cell *matCellDef="let assessment" style="width: 170px;">
                <div class="action-div">
                    <button class="btn-only" [routerLink]="'/fire-overview'"
                        [queryParams]="{assessment_id: assessment.assessment_id}">
                        View Fire<fa-icon [icon]="faChevronRight" aria-label="View All"></fa-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let assessment" [attr.colspan]="displayedColumns.length">
                <div class="example-element-detail"
                    [@detailExpand]="assessment == expandedAssessments ? 'expanded' : 'collapsed'">
                    <app-auth-report-list [assessment]="assessment" [isEditable]="false" [user]="user"
                        [reportList]="assessment.reports" style="width: 100%;"></app-auth-report-list>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
            [class.example-expanded-row]="expandedAssessments === element"
            (click)="expandedAssessments = expandedAssessments === element ? null : element"
            onkeypress="expandedAssessments = expandedAssessments === element ? null : element">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="13">
                <div class="no-data">
                    <div class="no-data-icon">
                        <mat-icon class="no-data-icon1">search</mat-icon>
                        <fa-icon [icon]="faFire" class="no-data-icon2"></fa-icon>
                    </div>
                    <div class="no-data-title">No assessments found</div>
                    <p>There are no assessments that match your current filters. Try removing some of them to get better
                        results.</p>
                    <button class="usa-button usa-button--secondary" (click)="clearSearch()">Clear Filters</button>
                </div>
            </td>
        </tr>
    </table>
    <mat-paginator [length]="length" [pageIndex]="pageNumber" [pageSize]="pageSize"
                   [pageSizeOptions]="[5, 10, 20, 50]"
        showFirstLastButtons (page)="pageEvent($event)" aria-label="Select page of fires">
    </mat-paginator>
</main>
